import { Box, Text } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

export const EmptyState = () => {
  return (
    <Box padding="s24" flexDirection="column" gap="s12" alignItems="center">
      <Text.Header2>{i18n.t('processes.materialize_process.detail.empty_step.title')}</Text.Header2>
      <Text.Normal color="grey800">
        {' '}
        {i18n.t('processes.materialize_process.detail.empty_step.description')}
      </Text.Normal>
    </Box>
  )
}
